import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/fisher-watch/dashboard")({
    component: () => <div>Hello /_app/fisher-watch/patients!</div>,
});
